import React from 'react';
import { ArrowLeft, Share2 } from 'lucide-react';
import * as v5 from '../../styles/v5.styles';
import { gradients } from '../../styles/v5.styles';

/**
 * Tela 1 — Boas-vindas
 * 
 * Entry point: PRIMEIRO_NOME. (serif, uppercase, substantivo próprio)
 * Body: frase-espelho do destino (Raleway Light, prata)
 * CTA: "Ver o que preparamos" (verbo + objeto concreto)
 * Meta: "Preparamos algo para você" (22% opacidade)
 */
export default function StorytellingIntro({ quote, onContinue, onShare }) {
  const defaultImage = 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80';
  const backgroundImage = quote.destination_image_url || defaultImage;

  const firstName = (quote.client_name || '').split(' ')[0];

  const getMirrorPhrase = () => {
    const dest = (quote.destination || '').toLowerCase();

    if (dest.includes('maceió') || dest.includes('mcz'))
      return 'Essa experiência foi pensada para alguém que valoriza praias paradisíacas, águas mornas e momentos inesquecíveis. Antes de falar sobre lugares, queremos falar sobre você.';
    if (dest.includes('gramado') || dest.includes('canela'))
      return 'Essa experiência foi pensada para alguém que valoriza conforto, ritmo tranquilo e boas histórias para lembrar. Antes de falar sobre lugares, queremos falar sobre você.';
    if (dest.includes('buenos aires'))
      return 'Essa experiência foi pensada para alguém que valoriza cultura, boa gastronomia e experiências autênticas. Antes de falar sobre lugares, queremos falar sobre você.';
    if (dest.includes('rio'))
      return 'Essa experiência foi pensada para alguém que valoriza paisagens deslumbrantes, energia vibrante e momentos marcantes. Antes de falar sobre lugares, queremos falar sobre você.';
    if (dest.includes('são paulo') || dest.includes('gru'))
      return 'Essa experiência foi pensada para alguém que valoriza diversidade, gastronomia de alto nível e experiências únicas. Antes de falar sobre lugares, queremos falar sobre você.';

    return 'Essa experiência foi pensada para alguém que valoriza momentos especiais, conforto e memórias para a vida toda. Antes de falar sobre lugares, queremos falar sobre você.';
  };

  return (
    <div style={{
      ...v5.screenBase,
      background: gradients.screen1.base,
    }}>
      {/* Background image */}
      <div style={{
        ...v5.screenBg,
        height: gradients.screen1.bgHeight,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <div style={v5.screenBgOverlay} />
      </div>

      {/* Top bar */}
      <div style={v5.topBar}>
        <button style={v5.iconBtn}>
          <ArrowLeft size={18} />
        </button>
        <button onClick={onShare} style={v5.iconBtn}>
          <Share2 size={18} />
        </button>
      </div>

      {/* Content: 3 níveis */}
      <div style={v5.screenContent}>
        <div style={v5.screenMeta}>Preparamos algo para você</div>
        <h1 style={v5.entryPoint}>{firstName}.</h1>
        <p style={v5.screenBody}>{getMirrorPhrase()}</p>
        <button onClick={onContinue} style={v5.ctaButton}>
          Ver o que preparamos
        </button>
      </div>
    </div>
  );
}
